import { FeatureFlags, useFeatureFlag } from '@src/hooks/useFeatureFlag';
import { ReactNode } from 'react';

interface FeatureFlagProps {
  active: () => ReactNode;
  feature: keyof typeof FeatureFlags;
  fallback?: () => ReactNode;
}

// In the future, we can handle multiple features at once
const FeatureFlag = (props: FeatureFlagProps) => {
  const { active = () => null, feature, fallback = () => null } = props;

  const { isFeatureFlagEnabled } = useFeatureFlag();

  const isActiveFeature = isFeatureFlagEnabled(feature);

  return isActiveFeature ? active() : fallback();
};

export default FeatureFlag;
